/* app/js/src/components/common/checkbox/checkbox.component.scss */
.checkbox-input {
  cursor: pointer;
  width: 14px;
  height: 14px;
  display: inline-block;
}
.checkbox-input svg {
  border: 1px solid;
  border-radius: 3px;
  width: 14px;
  height: 14px;
  margin: auto;
  fill-opacity: 0;
  position: relative;
  top: -3px;
}
.checkbox-input svg path {
  fill: white;
}
/*# sourceMappingURL=checkbox.component.css.map */
